module.exports = __webpack_public_path__ + "static/media/logo_whitelabel.a438eca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_whitelabel.png
// module id = 1655
// module chunks = 0